<template>
    <div class="form-item">
        <label for="user">Выбрать пользователя:</label>
        <div class="input-wrapper">
            <input type="text"
                   id="user"
                   class="text-input"
                   autocomplete="off"
                   v-model="email"
                   @input="getUserList()"
            />
            <div class="suggestion-list" v-show="email.length >= 3">
                <div class="inline" valign="center" v-show="status == 'loading'">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
                <div class="suggestion-content" v-show="list.length && status != 'loading'">
                    <div @click="selectUser(item)" v-for="(item, index) of list" :key="index">{{ item.email }}</div>
                </div>
                <div v-show="email.length >= 3 && !list.length && status != 'loading'">Не найдено</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                email: '',
                status: '',
                list: [],
                cancelToken: this.axios.CancelToken.source()
            }
        },
        methods: {
            selectUser (user) {
                this.$emit('changeUser', user)
                this.reset()
            },
            reset () {
              this.email = ''
              this.list = []
            },
            getUserList () {
                this.list = []
                if (this.status == 'loading') {
                    this.status = ''
                    this.cancelToken.cancel()
                    this.cancelToken = this.axios.CancelToken.source()
                }
                if (this.email.length < 3) return false
                return new Promise((resolve) => {
                    this.status = 'loading'
                    this.axios.get('api/admin/v2/user/search?email=' + this.email, {
                        cancelToken: this.cancelToken.token
                    }).then((resp) => {
                        if (resp.data.response) {
                            this.list = resp.data.response
                        } else {
                            this.list = []
                        }
                        this.status = ''
                        resolve()
                    }).catch(() => {})
                })
            }
        }
    }
</script>